import axios from "axios"
import helper from "helpers/fn_helper"

const baseUrl = process.env.REACT_APP_BACKEND_URL
export function UploadFile({ formData = {}, bucketName = "", fileName = "" }) {
  return axios.post(baseUrl + `/upload/${bucketName}/${fileName}`, formData, {
    headers: {
      authorization: helper.Auth.getToken(),
    },
    timeout: 20000,
  })
}
